import { render } from "./VariantImageUpload.vue?vue&type=template&id=3d7ecec4&scoped=true"
import script from "./VariantImageUpload.vue?vue&type=script&lang=js"
export * from "./VariantImageUpload.vue?vue&type=script&lang=js"

import "./VariantImageUpload.vue?vue&type=style&index=0&id=3d7ecec4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7ecec4"]])

export default __exports__